import { Typography } from "@mui/material";
import { useSelector } from "react-redux";

const renderSurgeryNote = (reqSoap) => (
  <div className="mh20">
    <div className="fs14 blue-color font-bold mt10">
      Pre-Surgical Documentation
    </div>
    <Typography className="fs12 txt-regular black">
      {reqSoap?.preSurgicalDocumentation}
    </Typography>
    <div className="fs14 blue-color font-bold mt10">
      Intra-Surgical Documentation
    </div>
    <Typography className="fs12 txt-regular black">
      {reqSoap?.intraSurgicalDocumentation}
    </Typography>
    <div className="fs14 blue-color font-bold mt10">
      Post-Surgical Documentation
    </div>
    <Typography className="fs12 txt-regular black">
      {reqSoap?.postSurgicalDocumentation}
    </Typography>
    <div className="fs14 blue-color font-bold mt10">Owner Communication</div>
    <Typography className="fs12 txt-regular black">
      {reqSoap?.ownerCommunication}
    </Typography>
    <div className="fs14 blue-color font-bold mt10">
      Additional Documentation
    </div>
    <Typography className="fs12 txt-regular black">
      {reqSoap?.additionalDocumentation}
    </Typography>
  </div>
);

const renderClinicalNote = (reqSoap) => (
  <div className="mh20">
    {reqSoap?.tag?.length > 0 ? (
      <div className="fs14 blue-color font-bold mt10">
        Diagnosis: {reqSoap?.tag ?? ""}
      </div>
    ) : null}
    {reqSoap?.subjective?.length > 0 ? (
      <>
        <div className="fs14 blue-color font-bold mt10">Subjective</div>
        <Typography className="fs12 txt-regular black">
          {reqSoap?.subjective}
        </Typography>
      </>
    ) : null}
    {reqSoap?.objective?.length > 0 ? (
      <>
        <div className="fs14 blue-color font-bold mt10">Objective</div>
        <Typography className="fs12 txt-regular black">
          {reqSoap?.objective}
        </Typography>
      </>
    ) : null}
    {reqSoap?.assessment?.length > 0 ? (
      <>
        <div className="fs14 blue-color font-bold mt10">Assessment</div>
        <Typography className="fs12 txt-regular black">
          {reqSoap?.assessment}
        </Typography>
      </>
    ) : null}
    {reqSoap?.plan?.length > 0 ? (
      <>
        <div className="fs14 blue-color font-bold mt10">Plan</div>
        <Typography className="fs12 txt-regular black">
          {reqSoap?.plan}
        </Typography>
      </>
    ) : null}
  </div>
);

const SoapNoteView = ({
  apntId,
  soapNote,
  soapNotes = null,
  isSurgery = false,
}) => {
  const reqDet = useSelector((state) => state?.pet?.complaintSummary?.data);

  const getDefaultSoapNote = () => {
    if (!apntId) return null;
    if (isSurgery) {
      return (
        reqDet?.inpatientNotes?.find(
          (cn) =>
            cn?.appointmentId === apntId &&
            cn?.type === "surgery" &&
            cn?.consolidated,
        ) ??
        reqDet?.inpatientNotes?.find(
          (cn) => cn?.appointmentId === apntId && cn?.type === "surgery",
        )
      );
    }
    return (
      reqDet?.clinicalNotes?.find(
        (cn) => cn?.appointmentId === apntId && cn?.consolidated,
      ) ??
      reqDet?.clinicalNotes?.find(
        (cn) => cn?.appointmentId === apntId && !cn?.consolidated,
      )
    );
  };

  const notesToRender = Array.isArray(soapNotes)
    ? soapNotes?.filter(Boolean)
    : soapNote
      ? [soapNote]
      : (() => {
          const defaultNote = getDefaultSoapNote();
          return defaultNote ? [defaultNote] : [];
        })();

  if (!notesToRender?.length) return null;

  const showNoteLabels = Array.isArray(soapNotes) && notesToRender.length > 0;

  return (
    <>
      {notesToRender.map((note, index) => (
        <div key={note?.id ?? note?.clinicalNoteId ?? `soap-note-${index}`}>
          {showNoteLabels ? (
            <div className="fs14 font-bold mt10 mh20">Note {index + 1}</div>
          ) : null}
          {isSurgery ? renderSurgeryNote(note) : renderClinicalNote(note)}
        </div>
      ))}
    </>
  );
};

export default SoapNoteView;
